import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  container: {
    position: "relative",
    zIndex: "-10"
  },
  map: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: "100%",
    height: props => props.height - 64
  }
});

export const MapContainer = React.forwardRef(({ children }, ref) => {
  const classes = useStyles({ height: window.innerHeight });

  return (
    <div className={classes.container}>
      <div className={classes.map} ref={ref} />
      {children}
    </div>
  );
});
